import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import TextInput from '@components/textInput/TextInput'

const TextInputsSection = () => {
  const [value, setValue] = React.useState<string>()

  return (
    <Section>
      <SectionTitle>Text Inputs</SectionTitle>
      <Container>
        <TextInput value={value} onChange={setValue} placeholder="Placeholder" />
      </Container>
      <Container>
        <TextInput value={value} onChange={setValue} hint="Hint" placeholder="Placeholder" />
      </Container>

      <Container>
        <TextInput title="Title" value={value} onChange={setValue} hint="Hint" placeholder="Placeholder" />
      </Container>
      <Container>
        <TextInput
          value={value}
          onChange={setValue}
          hint="Hint"
          right={{ name: 'send', onClick: () => undefined }}
          placeholder="Placeholder"
        />
      </Container>
      <Container>
        <TextInput value={value} onChange={setValue} hint="Hint" placeholder="Placeholder" right={{ name: 'done' }} />
      </Container>
      <Container>
        <TextInput value={value} onChange={setValue} hint="Hint" placeholder="Placeholder" left={{ name: 'search' }} />
      </Container>
      <Container>
        <TextInput
          value={value}
          title="Title"
          onChange={setValue}
          hint="Hint"
          placeholder="Placeholder"
          error="Error"
        />
      </Container>
      <Container>
        <TextInput disabled value={value} onChange={setValue} hint="Hint" placeholder="Placeholder" />
      </Container>
      <Container>
        <TextInput
          title="Title"
          disabled
          value={value}
          onChange={setValue}
          hint="Hint"
          placeholder="Placeholder"
          right={{ name: 'send' }}
        />
      </Container>
      <Container>
        <TextInput title="Title" value={value} onChange={setValue} placeholder="Placeholder" numberOfLines={5} />
      </Container>
      <Container back="dark">
        <TextInput
          searchStyle="onDark"
          value={value}
          onChange={setValue}
          placeholder="Placeholder"
          left={{ name: 'search' }}
        />
      </Container>
      <Container back="light">
        <TextInput
          searchStyle="onLight"
          value={value}
          onChange={setValue}
          placeholder="Placeholder"
          left={{ name: 'search' }}
        />
      </Container>
    </Section>
  )
}

export default TextInputsSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)<{ back?: 'dark' | 'light' }>`
  margin-bottom: 12px;
  ${(props) =>
    props.back &&
    `
  padding: 16px;
  background-color: ${props.back === 'dark' ? props.theme.colors.primary : props.theme.colors.background};`}
`
